export const FaqConstants = {
    General_Category : "2001",
    General_FAQs : "3001",
}